import "core-js/modules/es.array.reduce";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

var pipeP = function pipeP() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(v) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", fns.reduce( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, fn) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = fn;
                          _context.next = 3;
                          return r;

                        case 3:
                          _context.t1 = _context.sent;
                          return _context.abrupt("return", (0, _context.t0)(_context.t1));

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }(), v));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Vytvari pipe authentikace
 *
 * @param {string} storeKey
 * @param {Function} handleParentLogout
 * @param {Function} setContext
 *
 * @returns
 */


export default function createAuthenticatePipe(setStoredAuthData, getSortedAuthenticateHandlers, logout, authCallBack, setContext) {
  /**
   * Autentifikacni pipe.
   *
   * @param {Object} credentials
   * @param {string} [credentials.username]
   * @param {string} [credentials.password]
   * @param {Object} directContext
   * @param {string} [directContext.accessToken]
   * @param {Object} [directContext.user]
   * @param {Object} [directContext.meta]
   * @param {Array<string> | string} [directContext.scope]
   * @param {boolean} [directContext.isAuthenticated]
   * @param {*} [directContext.error]
   *
   * @returns {Object} Pokud je uspecna autentizace, vraci objekt autentifikacnich dat
   * ```ts
   * {
   *   accessToken: ?string,
   *   user: ?Object,
   *   meta: ?Object,
   *   scope: Array<string> | string,
   * }
   * ```
   * Jinak throw chybu.
   */
  function authenticate(_x4, _x5) {
    return _authenticate.apply(this, arguments);
  }

  function _authenticate() {
    _authenticate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(credentials, directContext) {
      var nau, preAuthContext, sortedAuthenticateHandlers, resultContext, _ref3, $remCred, error, isAuthenticated, authData;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              nau = function nau(o) {
                return _extends({
                  isAuthenticated: false
                }, o);
              };

              preAuthContext = nau(directContext || {
                credentials: credentials
              });
              sortedAuthenticateHandlers = getSortedAuthenticateHandlers();
              _context3.next = 5;
              return sortedAuthenticateHandlers.length > 0 ? pipeP.apply(void 0, _toConsumableArray(sortedAuthenticateHandlers))(preAuthContext) : preAuthContext;

            case 5:
              resultContext = _context3.sent;
              _ref3 = function (ctx) {
                if (ctx.error || !ctx.isAuthenticated) {
                  logout();
                  return {
                    error: ctx.error
                  };
                }

                return ctx;
              }(resultContext), $remCred = _ref3.credentials, error = _ref3.error, isAuthenticated = _ref3.isAuthenticated, authData = _objectWithoutProperties(_ref3, ["credentials", "error", "isAuthenticated"]);

              if (!isAuthenticated) {
                _context3.next = 12;
                break;
              }

              setStoredAuthData(authData);
              setContext(_extends({}, authData, {
                isAuthenticated: isAuthenticated
              }));
              authCallBack();
              return _context3.abrupt("return", authData);

            case 12:
              setStoredAuthData(null);
              setContext({
                scope: [''],
                isAuthenticated: false
              });

              if (!error) {
                _context3.next = 16;
                break;
              }

              throw error;

            case 16:
              return _context3.abrupt("return", {
                scope: ['']
              });

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _authenticate.apply(this, arguments);
  }

  return authenticate;
}